var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"config-form-builder-footer"}},[_vm._t("default",function(){return [_c('p',{staticClass:"label"},[_vm._v(_vm._s(_vm.content))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }